import { render, staticRenderFns } from "./ViewEventMenu.vue?vue&type=template&id=34a157df"
import script from "./ViewEventMenu.vue?vue&type=script&lang=ts"
export * from "./ViewEventMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports